import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createTextVNode as o, createVNode as s, defineComponent as c, normalizeClass as l, openBlock as u, reactive as d, ref as f, renderList as p, toDisplayString as m, unref as h, watch as g, withCtx as _ } from "vue";
import { PLACEHOLDER_UUID as v, getEntityAPIClient as y, registerEntityEndpoint as b } from "@editor/ui-utils";
import { QIcon as x, QTooltip as S } from "quasar";
import { EditorImage as C, getImage as w } from "@modules/image-editor-ui-components";
import { useI18n as T } from "vue-i18n";
//#region src/services/video.service.ts
var E = "Videos", D = b(E), O = y(E), { getEntity: k, listEntities: A } = D, j = async (e = null) => A({ params: { search: e || null } }), M = async (e) => (await A({ params: { contentId: e } })).list?.[0], N = async (e, t = !1) => k(e, { params: { includePreview: t } }), P = (e, t = 640, n = 360) => `${O.defaults.baseURL}/${e}/url/${t}/${n}`, F = () => ({
	type: "VIDEO",
	videoUuid: "",
	videoTeaser: ""
}), I = (e) => {
	let t = e ? new Date(e).getTime() : 1;
	return Math.ceil((t - (/* @__PURE__ */ new Date()).getTime()) / (1e3 * 60 * 60 * 24));
}, L = { class: "flex justify-start status-icons" }, R = { key: 0 }, z = {
	key: 1,
	class: "flex align-center overlay-padding"
}, B = {
	"data-qa-video-status-label-unpublished": "",
	class: "text-xsmall text-weight-medium q-mr-xs"
}, V = ["data-qa-video-status-label"], H = /* @__PURE__ */ c({
	__name: "video-status-label",
	props: {
		video: {},
		posterImageState: {}
	},
	setup(n) {
		let r = n, { t: c } = T(), l = t(() => {
			let e = [];
			if (r.video.state === "unpublish") return e.push({
				key: "unpublished",
				name: "alert-circle",
				color: "red",
				label: c("videos.components.videoUnpublished")
			}), e;
			let t = r.video.publishStartDate ? I(r.video.publishStartDate) : null, n = r.video.publishEndDate ? I(r.video.publishEndDate) : null;
			return t !== null && t <= 31 && t > 0 && e.push({
				key: "online",
				name: "clock",
				color: "teal-9",
				label: c("videos.components.videoPublish", { n: t })
			}), n !== null && n <= 31 && n > 0 && e.push({
				key: "expires",
				name: "clock",
				color: "red",
				label: c("videos.components.videoExpiresIn", { n })
			}), r.posterImageState !== "publish" && e.push({
				key: "expiredImage",
				name: "alert-circle",
				color: "teal-9",
				label: c("videos.components.videoPreviewImageExpired")
			}), e;
		});
		return (t, n) => (u(), i("div", L, [(u(!0), i(e, null, p(l.value, (t) => (u(), i("div", {
			key: t.key,
			class: "icon-wrapper"
		}, [l.value.length > 1 ? (u(), i("div", R, [s(h(x), {
			"data-qa-video-square-status": t.key,
			name: t.name,
			color: t.color,
			size: "16px"
		}, {
			default: _(() => [s(h(S), {
				anchor: "top middle",
				self: "top middle",
				offset: [10, 30],
				class: "bg-grey-10 text-white shadow-4"
			}, {
				default: _(() => [o(m(t.label), 1)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1032, [
			"data-qa-video-square-status",
			"name",
			"color"
		])])) : (u(), i("div", z, [t.key === "unpublished" ? (u(), i(e, { key: 0 }, [a("span", B, m(t.label), 1), s(h(x), {
			"data-qa-video-single-status": t.key,
			name: t.name,
			color: t.color,
			size: "16px"
		}, null, 8, [
			"data-qa-video-single-status",
			"name",
			"color"
		])], 64)) : (u(), i(e, { key: 1 }, [s(h(x), {
			"data-qa-video-single-status": t.key,
			name: t.name,
			color: t.color,
			size: "16px",
			class: "q-mr-xs"
		}, null, 8, [
			"data-qa-video-single-status",
			"name",
			"color"
		]), a("span", {
			"data-qa-video-status-label": t.key,
			class: "text-xsmall text-weight-medium"
		}, m(t.label), 9, V)], 64))]))]))), 128))]));
	}
}), U = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, W = /* @__PURE__ */ U(H, [["__scopeId", "data-v-5fdafd12"]]), G = d({ currentVideo: void 0 }), K = () => G, q = {
	"data-qa-video-preview": "",
	class: "video-preview"
}, J = ["src"], Y = /* @__PURE__ */ U(/* @__PURE__ */ c({
	__name: "editor-video",
	props: {
		square: {
			type: Boolean,
			default: !1
		},
		layout: { default: "video" },
		entity: { default: "" },
		videoData: {}
	},
	setup(e) {
		let t = e, o = K(), c = f(!1), d = f(), p = f("publish"), m = () => {
			c.value = !0, o.currentVideo = t.videoData?._id || "", d.value?.play();
		}, _ = async () => {
			t.videoData?.posterImageUuid && t.videoData.posterImageUuid !== v && (p.value = (await w(t.videoData.posterImageUuid)).image.state);
		};
		g(o, () => {
			o.currentVideo != t.videoData._id && (d.value?.pause(), c.value = !1);
		}), g(() => t.videoData.posterImageUuid, async () => {
			t.videoData.posterImageUuid ? await _() : p.value = "publish";
		}, { immediate: !0 });
		let y = (e) => {
			let t = (e.currentTarget instanceof HTMLElement ? e.currentTarget : void 0)?.parentNode?.querySelector(".video");
			c.value = !c.value, t instanceof HTMLVideoElement && t.pause();
		}, b = t.videoData?.videoRenditions?.[0]?.src || "", S = f(!1);
		return (o, f) => (u(), i("div", {
			class: l([e.layout === "video" ? "" : e.layout, "video-wrapper"]),
			onMouseenter: f[0] ||= (e) => S.value = !0,
			onMouseleave: f[1] ||= (e) => S.value = !1
		}, [a("div", { class: l({ videoActive: c.value }) }, [
			a("div", {
				class: "play-btn-close",
				onClick: y
			}, [s(h(x), {
				name: "close",
				size: "24px",
				class: "btn-close q-mr-sm",
				color: "white"
			})]),
			a("div", q, [
				a("div", {
					class: "play-btn",
					onClick: m
				}),
				s(h(C), {
					uuid: t.videoData.posterImageUuid ?? "",
					size: "smallVideo",
					entity: e.entity,
					square: e.square
				}, null, 8, [
					"uuid",
					"entity",
					"square"
				]),
				d.value ? (u(), n(W, {
					key: 0,
					video: t.videoData,
					"poster-image-state": p.value
				}, null, 8, ["video", "poster-image-state"])) : r("", !0)
			]),
			a("video", {
				ref_key: "video",
				ref: d,
				"data-qa-video": "",
				class: "video",
				width: "212",
				height: "120",
				controls: "",
				controlslist: "nodownload noplaybackrate noremoteplayback",
				disablePictureInPicture: ""
			}, [a("source", {
				src: h(b),
				type: "video/mp4"
			}, null, 8, J)], 512)
		], 2)], 34));
	}
}), [["__scopeId", "data-v-daa3b968"]]);
//#endregion
export { D as a, M as c, E as i, P as l, U as n, F as o, I as r, N as s, Y as t, j as u };

//# sourceMappingURL=editor-video-CKpx_3uk.js.map